import { ReportMetric, ReportMetricRequirement } from 'apis/merchant-gateway/insights';

export const isMetricSupported = (
  metric: ReportMetric,
  isOnlyPickerEnabledVenues: boolean,
  isOnlyWoltPlusVenuesSelected: boolean,
) => {
  if (metric.requires.includes(ReportMetricRequirement.PICKER_ENABLED) && !isOnlyPickerEnabledVenues) {
    return false;
  }

  if (metric.requires.includes(ReportMetricRequirement.WOLT_PLUS) && !isOnlyWoltPlusVenuesSelected) {
    return false;
  }

  if (
    metric.requires.includes(ReportMetricRequirement.WOLT_PLUS) &&
    !isOnlyWoltPlusVenuesSelected &&
    metric.requires.includes(ReportMetricRequirement.PICKER_ENABLED) &&
    !isOnlyPickerEnabledVenues
  ) {
    return false;
  }

  return true;
};
